
<!-- breadcrumb -->
<div class="breadcrumb-header justify-content-between">
  <div class="left-content">
    <span class="main-content-title mg-b-0 mg-b-lg-1">
        {{title}}
    </span>
    <div>
        {{ question }}
    </div>
  </div>
  <div class="justify-content-center mt-1">
    <ol class="breadcrumb">
      @for (item of items; track item) {
        <li class="breadcrumb-item fs-15"><a href="javascript:void(0);">{{item}}</a></li>
      }
      <li class="breadcrumb-item active" aria-current="page">{{active_item}}</li>
    </ol>
  </div>
</div>
<!-- /breadcrumb -->
